import React, { useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { connect } from 'react-redux'

import { uploadFile } from '../../services/saga'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import CircularProgress from '@material-ui/core/CircularProgress'
import Paper from '@material-ui/core/Paper'

import Icon from '@material-ui/core/Icon'
import Button from '@material-ui/core/Button'
import Alert from '@material-ui/lab/Alert'

import Slide from '@material-ui/core/Slide'
import Snackbar from '@material-ui/core/Snackbar'

import Tooltip from '@material-ui/core/Tooltip'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'

const thumbsContainer = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  marginTop: 16
}

const thumb = {
  display: 'inline-flex',
  borderRadius: 2,
  border: '1px solid #eaeaea',
  marginBottom: 8,
  marginRight: 8,
  width: 100,
  height: 100,
  padding: 4,
  boxSizing: 'border-box'
}

const thumbInner = {
  display: 'flex',
  minWidth: 0,
  overflow: 'hidden'
}

const img = {
  width: '30px'
}

const dropzoneCss = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: '2px',
  borderRadius: '2px',
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: ' #bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out'
}

function SlideTransition(props) {
  return <Slide {...props} direction='up' />
}

function Previews(props) {
  const [files, setFiles] = useState([])

  const [status, setStatus] = useState([])

  const [uploadedFiles, setUploadedFiles] = useState([])

  const [open, setOpen] = React.useState(false)

  const [uploadBtnState, setUploadBtnState] = useState('NEW')

  const handleSnackbarClose = () => {
    setOpen(false)
  }

  const handleTooltipOpen = () => {
    setOpen(true)
  }

  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/*',
    onDrop: (acceptedFiles) => {
      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
            link: ''
          })
        )
      )

      // setStatus()
    },
    maxSize: 100000
  })

  // const thumbs = files.map(file => (
  //   <div style={thumb} key={file.name}>
  //     <div style={thumbInner}>
  //       <img
  //         src={file.preview}
  //         style={img}
  //       />
  //     </div>
  //   </div>
  // ));

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = (error) => reject(error)
    })
  }

  useEffect(() => {
    async function fetchMyAPI() {
      files.forEach(async (file) => {})
    }

    fetchMyAPI()
  }, [files])

  const removeFile = (value) => {
    const newFiles = [...files] // make a var for the new array
    newFiles.splice(value, 1) // remove the file from the array
    setFiles(newFiles)
  }

  const uploadSubmit = async () => {
    let count = 0
    let mainArr = []

    await Promise.all(
      files.map(async (file) => {
        setUploadBtnState('UPLOADING')

        let getFile = await getBase64(file)
        let upload = await uploadFile(getFile)

        var upArray = []

        var obj = {}
        ;(obj['file'] = file.name), (obj['link'] = upload.fileName)

        mainArr.push(obj)
      })
    )

    setUploadBtnState('UPLOADED')
    setUploadedFiles(mainArr)
  }

  const refreshPage = () => {
    window.location.reload()
  }

  const copyText = (e) => {
    navigator.clipboard.writeText(e.link)
    setOpen(true)
  }

  const uploadCheck = (file) => {
    let check = uploadedFiles.filter((data) => data.file == file.name)

    if (check.length != 0) {
      return (
        <div style={{ cursor: 'pointer' }}>
          <Alert
            onClick={() => {
              copyText(check[0])
            }}
            severity='success'
          >
            {check[0].link}
          </Alert>
        </div>
      )
    }

    return null
  }

  const deleteCheck = (file, i) => {
    let check = uploadedFiles.filter((data) => data.file == file.name)

    if (check.length === 0) {
      return (
        <div>
          <Icon
            onClick={() => {
              removeFile(i)
            }}
            color='primary'
          >
            deleteForever
          </Icon>
        </div>
      )
    }

    return <Icon color='primary'>checkCircleOutline</Icon>
  }

  return (
    <section className='container'>
      <ul>
        <b>Instructions:</b>
        <li>
          Get Icons from:{' '}
          <a target='_blank' href='https://www.flaticon.com/'>
            https://www.flaticon.com/
          </a>{' '}
        </li>
        <li>Use Always INSEAD Branding</li>
        <li>Max File Size: 100KB</li>
        <li>
          If the image is large than 100KB use image optimizer:{' '}
          <a target='_blank' href='https://imagecompressor.com/'>
            https://imagecompressor.com/
          </a>{' '}
        </li>
      </ul>

      <div style={dropzoneCss} {...getRootProps({ className: 'dropzone' })}>
        <input {...getInputProps()} />
        <p>Drag 'n' drop images/icons here, or click to select files</p>
      </div>

      <aside style={thumbsContainer}>
        {files.length !== 0 ? (
          <TableContainer component={Paper}>
            <Table aria-label='simple table'>
              <TableHead>
                <TableRow>
                  <TableCell>Number</TableCell>
                  <TableCell>File Name</TableCell>
                  <TableCell>Image</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {files.map((file, i) => (
                  <TableRow key={file + '-' + i}>
                    <TableCell>1</TableCell>
                    <TableCell>{file.name}</TableCell>
                    <TableCell>
                      <img src={file.preview} style={img} />
                      {uploadCheck(file)}
                    </TableCell>
                    <TableCell>{deleteCheck(file, i)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : null}

        <div style={{ marginTop: 10 }}>
          <Button
            disabled={uploadBtnState !== 'NEW'}
            variant='contained'
            color='primary'
            onClick={uploadSubmit}
            style={{ marginRight: 10 }}
          >
            Upload Images
          </Button>

          {uploadBtnState !== 'NEW' ? (
            <Button variant='contained' color='primary' onClick={refreshPage}>
              Start Over
            </Button>
          ) : null}
        </div>

        <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          autoHideDuration={1000}
          open={open}
          onClose={handleSnackbarClose}
          TransitionComponent={SlideTransition}
          message=''
          key={'ddd'}
        >
          <Alert onClose={handleSnackbarClose} severity='info'>
            Link Copied
          </Alert>
        </Snackbar>
      </aside>
    </section>
  )
}

function mapStateToProps(state) {
  return {
    data: state.Zoom
  }
}

const mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(Previews)
